export default "__VITE_ASSET__DJIvOpVc__"